import Axios from 'axios'
import {promoCodeTypeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_promo_code_types (context) {
    Axios.get(promoCodeTypeUrls.getAllPromoCodeTypes).then(function (response) {
      context.commit('GET_ALL_PROMO_CODE_TYPES', response.data)
    })
  },
  get_promo_code_types (context, publicId) {
    Axios.get(promoCodeTypeUrls.getPromoCodeTypes + publicId).then(function (response) {
      context.commit('GET_PROMO_CODE_TYPES', response.data)
    })
  },
  get_deleted_promo_code_types (context) {
    Axios.get(promoCodeTypeUrls.getDeletedPromoCodeType).then(function (response) {
      context.commit('GET_DELETED_PROMO_CODE_TYPES', response.data)
    })
  },
  get_promo_code_type (context, publicId) {
    Axios.get(promoCodeTypeUrls.getPromoCodeType + publicId).then(function (response) {
      context.commit('GET_PROMO_CODE_TYPE', response.data)
    })
  },
  post_promo_code_type (context, data) {
    Axios.post(promoCodeTypeUrls.postPromoCodeType, data).then(function () {
      context.dispatch('get_all_promo_code_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_promo_code_type (context, data) {
    Axios.post(promoCodeTypeUrls.editPromoCodeType + '/' + data.public_id, data).then(function () {
      context.dispatch('get_all_promo_code_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_promo_code_type (context, data) {
    Axios.post(promoCodeTypeUrls.deletePromoCodeType + data.public_id, data).then(function (response) {
      context.commit('GET_DELETED_PROMO_CODE_TYPES', response.data)
      context.dispatch('get_all_promo_code_types')
      // router.push({
      //   name: 'Module.DeletedPromoCodeTypes'
      // })
    })
  },
  restorePromoCodeType (context, publicId) {
    Axios.get(promoCodeTypeUrls.restorePromoCodeType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_PROMO_CODE_TYPES', response.data)
      router.push({
        name: 'Module.PromoCodeTypes'
      })
    })
  }
}
